export default __webpack_public_path__ + "static/media/maintenance.52c31688.svg";